import { ReactNode } from 'react';
import { NavLink } from 'react-router-dom';
import { Text } from '../ui';
import clsx from 'clsx';

interface NavItemProps {
  label: string;
  to: string;
  icon: ReactNode;
  hasNotification?: boolean;
}

export function NavItem({ label, to, icon, hasNotification }: NavItemProps) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        clsx(
          'py-2xs px-xs gap-2xs flex items-center rounded-lg transition-all focus:outline-2 focus:outline-offset-2',
          isActive && 'bg-base-white text-brand-default outline-brand-subtle shadow-xs',
          !isActive && 'text-neutral-default hover:bg-base-white outline-neutral-subtle'
        )
      }
    >
      <div className="relative">
        {icon}
        {hasNotification && (
          <span className="h-2xs bg-error-default absolute -top-[1px] -right-[1px] w-2xs rounded-full" />
        )}
      </div>
      <Text variant="label" strong>
        {label}
      </Text>
    </NavLink>
  );
}
